import { gql } from 'apollo-boost';

export const paged = gql`
  query paged(
    $orgId: ID!
    $limit: Int!
    $offset: Int!
    $includeExpired: Boolean!
  ) {
    carrier {
      paged(
        orgId: $orgId
        limit: $limit
        offset: $offset
        includeExpired: $includeExpired
      ) {
        results {
          id
          name
          scac
          ratingPhoneNumber
          dispatchPhoneNumber
          customerServicePhoneNumber
          insurancePolicyNumber
          carrierStatusId
          netTermsId
          active
          rowVersion
          leadTimeWindowMinutes
        }
        totalCount
      }
    }
  }
`;

export const byId = gql`
  query byId($id: ID!) {
    carrier {
      byId(id: $id) {
        id
        active
        name
        externalId
        scac
        leadTimeWindowMinutes
        ratingUrl
        ratingPhoneNumber
        dispatchUrl
        dispatchPhoneNumber
        customerServicePhoneNumber
        mcNumber
        dunsNumber
        usDotNumber
        federalEinNumber
        p44AccountCode
        insuranceProvider
        insurancePolicyNumber
        insuranceEffectiveDate
        insuranceExpirationDate
        carrierStatusId
        netTermsId
        rowVersion
      }
    }
  }
`;

export const all = gql`
  query all($orgId: ID!) {
    carrier {
      all(orgId: $orgId) {
        id
        active
        name
        externalId
        scac
        leadTimeWindowMinutes
        ratingUrl
        ratingPhoneNumber
        dispatchUrl
        dispatchPhoneNumber
        customerServicePhoneNumber
        mcNumber
        dunsNumber
        usDotNumber
        federalEinNumber
        insuranceProvider
        insurancePolicyNumber
        insuranceEffectiveDate
        insuranceExpirationDate
        carrierStatusId
        rowVersion
      }
    }
  }
`;

export const forSelect = gql`
  query carriersForSelect($orgId: ID!) {
    carrier {
      all(orgId: $orgId) {
        id
        name
      }
    }
  }
`;
